import React, { useCallback } from 'react';
import { t } from 'i18next';

import MModal from 'Components/modal/MModal/MModal';

import styles from './SaveCampaignAudienceModal.style';

type Props = {
  onAction: (success: boolean) => void;
  scope: 'campaign' | 'breaking-news';
};

export const SaveAudienceModal = ({ onAction, scope }: Props) => {
  const activityName =
    scope === 'campaign' ? t('activities:audience.campaign_scope') : t('activities:audience.breaking_news_scope');

  const onValidate = useCallback(() => onAction(true), [onAction]);
  const onDismiss = useCallback(() => onAction(false), [onAction]);

  return (
    <MModal
      visible
      onCloseModal={onDismiss}
      onAction={onValidate}
      onSecondAction={onDismiss}
      type="dialog"
      title={t('activities:modals.save.title', { activity: activityName })}
      labelActionButton={t('activities:modals.save.button', { activity: activityName })}
      labelSecondButton={t('activities:modals.save.cancel')}
      actionButtonType="destructive"
    >
      <div style={styles.content}>{t('activities:modals.save.content')}</div>
    </MModal>
  );
};
